import useLogin from 'modules/oidc/useLogin';
import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

const LoginRedirect = () => {
	const { activeNavigator } = useAuth();
	const login = useLogin();

	useEffect(() => {
		// prevent calling signin while signing in
		if (activeNavigator) return;

		login();
	}, [login, activeNavigator]);

	return <div />;
};

export default LoginRedirect;
